// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function TotalOneTimeRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (
      state.user_view == 'Internal' ||
      state.totalImplementationCosts.totalPrice > 0
   )
      return (
         <div className='row'>
            <div className='col-bhr1'>
               <b>{getString('product.TotalOneTimeRow.ProductName')}</b>
            </div>
            <div className='col-bhr2'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               <b>
                  {formatFloatAsCurrencySymbol(
                     state.totalImplementationCosts.totalPrice,
                     state.currencyObject,
                  )}
               </b>
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
